import * as React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { PersistGate } from 'redux-persist/integration/react'
import * as Sentry from '@sentry/browser';
import { getCookie } from './app/infrastructure/helpers';
const uuidv1 = require('uuid/v1');

import './app/i18n';

import store, { history, persistor } from './store'
import App from './app/App';
import { checkAuthState } from './app/modules/auth/store/auth-user/actions';

import registerServiceWorker from './registerServiceWorker';

import './styles/styles.scss';

const target = document.querySelector('#root');
store.dispatch(checkAuthState());

Sentry.init({dsn: "https://548b370d874342d0b64fdf1ca9c3050f@sentry.io/1816422"});

if (!getCookie('accessToken')) {
  document.cookie = `accessToken=${uuidv1()}; path=/;`;
}

render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <App/>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  target
);

// test changes for deploy

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.jsx